module.exports = __webpack_public_path__ + "static/media/logo-banner.d843eb9f.png";